
import {
    GET_ALL_MANAGEMENT
   } from "../../constant/ActionType";
   
   export default function GetAllMaintenanceType(state = {
    allMaintenanceData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_MANAGEMENT:
               return {
                   ...state,
                   allMaintenanceData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }